/**
 * SummaryFieldWithCitations Component (Simplified for Normalized Schema)
 *
 * Wrapper component that displays summary field text with inline citation pills.
 * Supports bold emphasis and LaTeX with or without citations.
 */

import React from 'react';
import { Text, StyleSheet } from 'react-native';
import type { SummaryField } from './types';
import { parseTextWithCitations } from '../../utils/citationParser';
import { interRegular } from "../../lib/fonts";


interface PillPosition {
    y: number;
    height: number;
}

interface SummaryFieldWithCitationsProps {
    field: SummaryField | undefined;  // The field data from summary.fields[fieldType]
    fontsLoaded?: boolean;
    style?: any;
    onHoverChange?: (isHovered: boolean, tooltipText?: string, position?: PillPosition) => void;
}

export default function SummaryFieldWithCitations({
    field,
    fontsLoaded = false,
    style,
    onHoverChange,
}: SummaryFieldWithCitationsProps) {
    console.log('[SummaryFieldWithCitations] Received field:', field);

    // If no field data, render nothing
    if (!field) {
        console.log('[SummaryFieldWithCitations] Field is null/undefined, returning null');
        return null;
    }

    // Parse text with citations to get array of text fragments and pills
    const elements = parseTextWithCitations(
        field.content,
        field.citations,
        onHoverChange,
        [styles.text, fontsLoaded && interRegular, style],
        fontsLoaded
    );

    // Render text with inline citation pills
    return (
        <Text style={[styles.text, fontsLoaded && interRegular, style]}>
            {elements}
        </Text>
    );
}

const styles = StyleSheet.create({
    text: {
        fontSize: 15,
        color: '#374151', // colors.text700
        lineHeight: 22,
    },
});
